// Module
var code = `<div role="button" data-bind="css: 'svc-element__add-new-question ' + buttonClass, click: data.addNewQuestion, key2click, clickBubble: false, event: { mouseover: function(m, e) { data.hoverStopper && data.hoverStopper(e, \$element); }}">
  <!-- ko component: { name: 'sv-svg-icon', params: { css: 'svc-panel__add-new-question-icon', iconName: 'icon-add_24x24', size: 'auto' } } -->
  <!-- /ko -->
  <span class="svc-add-new-item-button__text" data-bind="text: data.addNewQuestionText">
  </span>
  <!-- ko if: \$data.renderPopup -->
  <!-- ko component: { name: "svc-add-question-type-selector", params: { questionTypeSelectorModel: data.questionTypeSelectorModel, renderPopup: renderPopup } } -->
  <!-- /ko -->
  <!-- /ko -->
</div>
<!-- ko ifnot: \$data.renderPopup -->
<!-- ko component: { name: "svc-add-question-type-selector", params: { questionTypeSelectorModel: data.questionTypeSelectorModel, renderPopup: renderPopup } } -->
<!-- /ko -->
<!-- /ko -->`;
// Exports
export default code;